var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"overline font-weight-bold d-flex align-center",class:_vm.customClass},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }